import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2768_513)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.70538 15.2954C7.09466 15.6847 7.72569 15.685 8.11538 15.2962L12 11.42L15.8846 15.2962C16.2743 15.685 16.9053 15.6847 17.2946 15.2954C17.6842 14.9058 17.6842 14.2742 17.2946 13.8846L12.7071 9.29711C12.3166 8.90658 11.6834 8.90658 11.2929 9.29711L6.70538 13.8846C6.31581 14.2742 6.31581 14.9058 6.70538 15.2954Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2768_513",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgArrowUp;
